export enum VerificationRequestPaymentTryAgainFormFields {
  paymentMethodId = 'paymentMethodId',
}

export type VerificationRequestPaymentTryAgainFormValues = {
  [VerificationRequestPaymentTryAgainFormFields.paymentMethodId]: string;
};
